export default class Dependente {
  constructor(
    id = null,
    responsavelId = null,
    tipoDependenteId = null,
    nome = '',
    mae = '',
    sexo = '',
    cpf = '',
    dataNascimento = '',
    alteracaoEstadoCivil = false,
    anexos = []
  ) {
    this.id = id;
    this.responsavelId = responsavelId;
    this.tipoDependenteId = tipoDependenteId;
    this.nome = nome;
    this.mae = mae;
    this.sexo = sexo;
    this.cpf = cpf;
    this.dataNascimento = dataNascimento;
    this.alteracaoEstadoCivil = alteracaoEstadoCivil;
    this.anexos = anexos;
  }
}



// WEBPACK FOOTER //
// ./src/domain/recadastroDependente/index.js